/* globals gapi */
export default {
  data() {
    return {
      CLIENT_ID: '',
      GoogleApiLoaded: false,
      auth2: {}, // The Sign-In object.
      googleUser: {}, // The current user.
    }
  },

  mounted() {
    if (!this.GoogleApiLoaded) {
      let promise = this.loadGoogleApi()
      this.$uiBlocker(promise)
      promise.then(() => {
        this.GoogleApiLoaded = true
        this.$nextTick(this.configureGoogleApi)
      })
    } else {
      this.GoogleApiLoaded = true
      this.$nextTick(this.configureGoogleApi)
    }
    const savedToken = localStorage.getItem('googleToken');
    if (savedToken) {
      this.googleToken = savedToken;
      const decodedToken = JSON.parse(atob(savedToken.split('.')[1]));
      this.username = decodedToken.name;
      this.setGmail(decodedToken.email);
      this.signed = true;
    }
  },

  methods: {
    loadGoogleApi() {
      return new Promise(resolve => {
        let api = document.createElement('script')
        api.onload = resolve
        api.setAttribute('src', 'https://accounts.google.com/gsi/client')
        document.head.appendChild(api)
      })
    },
    configureGoogleApi() {
      this.handleClientLoad()
    },
    async handleClientLoad() {
      window.google.accounts.id.initialize({
        client_id: this.$settings.google_api_calendar_id,
        callback: this.handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
      });
    },
    appendPre(message) {
      var pre = document.getElementById('content')
      var textContent = document.createTextNode(message + '\n')
      if (pre) pre.appendChild(textContent)
    },
    clearPre() {
      var pre = document.getElementById('content')
      if (pre) pre.innerHTML = ''
    },
  },
}
